import { PersonRecord } from "@/common/PersonRecord";
import { useRuntimeImage } from "@/entities/runtime-image";
import type { Person } from "@/services/api";
import type { FC } from "react";

type Props = {
  person: Person;
};

export const Option: FC<Props> = ({ person }) => {
  const { getRuntimeImageURL } = useRuntimeImage();
  return (
    <PersonRecord
      avatar={getRuntimeImageURL({ fileId: person?.avatarFile?.fileId ?? "" })}
      group={person.group ?? ""}
      name={`${person.firstName ?? ""} ${person.middleName ?? ""} ${person.lastName ?? ""}`}
      selected={false}
    />
  );
};
